const setDealDetails = _ref => {
  let {
    types
  } = _ref;
  return payload => dispatch => {
    const deals = payload.reduce((acc, deal) => {
      acc[deal.id] = {
        ...deal
      };
      return acc;
    }, {});
    dispatch({
      type: types.SET_DEAL_DETAILS,
      payload: {
        ...deals
      }
    });
  };
};
export default setDealDetails;